/* import __COLOCATED_TEMPLATE__ from './header.hbs'; */
/* RESPONSIBLE TEAM: team-phone */
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import type IntlService from 'ember-intl/services/intl';
import type { WebsocketState } from 'embercom/services/fin-voice-service';

export interface HeaderArgs {
  connectionState: WebsocketState;
  hasSessions: boolean;
  isLogsVisible: boolean;
  verboseLogsEnabled: boolean;
  allowDevFeatures: boolean;
  isSideMenuOpen: boolean;
  copyLatestSessionId: () => Promise<void>;
  clearAllSessions: () => void;
  toggleVerboseLogsEnabled: () => void;
  openSideMenu: () => void;
  reportIssue: () => void;
}

interface Signature {
  Args: HeaderArgs;
  Element: HTMLElement;
}

export default class Header extends Component<Signature> {
  @service declare intl: IntlService;

  get isDisconnected() {
    return this.args.connectionState === 'disconnected';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::VoicePlayground::Header': typeof Header;
  }
}
